import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { ContentHeaderPersonFragmentDoc } from '../fragments/ContentHeaderPerson.fragment';
export type GetContentHeaderPersonQueryVariables = Types.Exact<{
	nodeId: Types.Scalars['ID']['input'];
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
}>;

export type GetContentHeaderPersonQuery = {
	__typename?: 'Query';
	node?:
		| { __typename?: 'Article' }
		| { __typename?: 'Author' }
		| { __typename?: 'Bundle' }
		| { __typename?: 'Device' }
		| { __typename?: 'Episode' }
		| { __typename?: 'GenericTitleList' }
		| { __typename?: 'Genre' }
		| { __typename?: 'Movie' }
		| { __typename?: 'MultiStepSportEvent' }
		| { __typename?: 'Offer' }
		| { __typename?: 'Package' }
		| { __typename?: 'Page' }
		| {
				__typename?: 'Person';
				id: string;
				content: {
					__typename?: 'PersonContent';
					fullName: string;
					shortDescription?: string | null;
					dateOfBirth?: any | null;
				};
		  }
		| { __typename?: 'Season' }
		| { __typename?: 'Show' }
		| { __typename?: 'SingleStepSportEvent' }
		| { __typename?: 'SportCompetitionV2' }
		| { __typename?: 'SportCompetitorV2' }
		| { __typename?: 'Url' }
		| null;
};

export const GetContentHeaderPersonDocument = gql`
	query GetContentHeaderPerson($nodeId: ID!, $country: Country!, $language: Language!) {
		node(id: $nodeId) {
			... on Person {
				...ContentHeaderPerson
			}
		}
	}
	${ContentHeaderPersonFragmentDoc}
`;
